import { InvoiceDisplayData, PaginationRequest } from '@monorepo/types';
import { getEnv } from '@hub/helpers/getters.store';
import PurchaseService from '../../../services/entities/purchase-service';

export default class PurchaseStore {
  private service: PurchaseService;

  constructor() {
    const {
      apiFactory: { purchaseService },
    } = getEnv();
    this.service = purchaseService;
  }

  async paginate(payload: PaginationRequest) {
    return await this.service.paginate(payload);
  }

  async getCurrencies() {
    try {
      return await this.service.getCurrencies();
    } catch (e) {
      console.log(e);
      throw e;
    }
  }

  async getPurchaseInvoice(purchaseId: string): Promise<InvoiceDisplayData> {
    try {
      return await this.service.getPurchaseInvoice(purchaseId);
    } catch (e) {
      console.error(e);
      throw e;
    }
  }
}
